<section class="inner-page-section">
    <div class="container">
        <h1>Services</h1>
        <p><strong>All the expert services you need to do your job with optimal effectiveness and efficiency</strong>
        </p>
        <p>Here are the transformational benefits you’ll enjoy with the complete transparency ENL Solutions delivers:
        </p>
        <h3>Shippers</h3>
        <p>Instead of limiting the number of shipping solutions available to you or spending time searching for
            individual solutions online, you’ll be able to – </p>
        <ul>
            <li>Easily search and compare multiple solutions</li>
            <li>Select the best possible price from multiple providers</li>
        </ul>
        <h3>Freight Forwarders</h3>
        <p>Instead of relying on one shipping line to fulfill your orders, you can –</p>
        <ul>
            <li>Search and compare multiple shipping lines with ease</li>
            <li>Get information on planned arrivals of vessels to make it easier to organize transport</li>
        </ul>
        <h3>Port Operators and Suppliers</h3>
        <p>Instead of operating without information on planned port movements, you’ll be able to – </p>
        <ul>
            <li>See all the plans of your contract partners</li>
            <li>Plan and organize port operations to make them far more efficient </li>
        </ul>
        <h3>Shipping Lines</h3>
        <p>Instead of operating without information about the plans of your competitors and sending vessels to ports
            blindly, you can – </p>
        <ul>
            <li>See all the information about the plans of your competitors</li>
            <li>Plan vessel movements with transformational insight and efficiency</li>
        </ul>
        <p><strong>Enjoy a free 30-day trial </strong>
            Simply complete the simple form below and then click on Submit.</p>
        <p>  
            <a class="nav-link" routerLink="/signup" routerLinkActive="active">Register Here</a>
        </p>
        <h3>WHY US?</h3>
        <p><strong>The transparent, updated-daily information you need to perform at your best </strong></p>
        <p>There are a number of reasons you should make ENL Solutions your go-to hub for shipping information and
            rates.</p>
        <ol>
            <li>As a shipping professional, you know the industry has traditionally treated much of its data as
                proprietary information, particularly information about shipping rates.</li>
            <li>There has not been a convenient, interactive one-stop where you can conveniently access the shipping
                schedules of major cargo lines.</li>
        </ol>
        <p><strong>ENL Solutions solves traditional difficulties of shipping cargo with transformational expertise and
                ease</strong></p>
        <p>Imagine the remarkable difference! </p>
        <ul>
            <li>If you’re a shipper, you never again have to search individual schedules online to find a ship that will
                get your cargo to its destination on time or how much it will cost to ship it.</li>
            <li>If you’re a freight forwarder, you can go beyond the circle of your usual clients and start to provide
                quotes for lots of new customers.</li>
            <li>And as a port operator or supplier, you never have to worry about getting shipping information late,
                dealing with unpredictable shipping volume or being concerned if you have enough supplies on hand to
                meet demand. Instead, you can plan with transparent knowledge of daily and future shipping volume. So
                you can increase efficiency, customer satisfaction, and profit margins.</li>
        </ul>
        <p><strong>Enjoy a 30-day free trial</strong>
            Then, if you decide to continue your membership, pay just $xx.xx a month. Cancel at any time.</p>
        <p><strong>Sign up today</strong>
            Simply fill out the easy registraton form below.</p>
        <h3>REGISTER</h3>
        <p><strong>Select the plan that’s right for you and then enjoy your free 30-day trial </strong></p>
        <!-- <p>[Insert chart with plan levels and benefits]</p> -->
        <div class="middle-section">
            <div class="container">
                <div class="main-section">
                 
                        <div class="rate-request-form">
                            <div class=" table-resposive">
                                <div class="col-md-12 overflow-auto">
                                    <table class="table  table-plan table-bordered ">
                                        <tr>
                                            <th></th>
                                            <th *ngFor="let plan of planData">
                                                {{plan.planName}}                                                
                                            </th>
                                        </tr>
                                        <tr class="box">
                                            <td><strong>Price Table</strong></td>
                                            <td *ngFor="let plan of planData" [ngClass]="{
                                                'box-yellow':plan.planName === 'Basic',
                                                'box-blue':plan.planName === 'Advanced',
                                                'box-green':plan.planName === 'Pro',
                                                'box-voilate':plan.planName === 'Pro+',
                                                'box-pink':plan.planName === 'Elite'
                                              }">
                                                <span *ngIf="plan.planCost > 0">${{plan.planCost}}/Month</span>
                                                <span *ngIf="plan.planCost == 0">Free</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let item of searchCategories">
                                            <td>
                                                {{item.name}}
                                            </td>
                                            <td *ngIf="basic == true">
                                                <div *ngIf="item.isBsic == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                    <!-- <h6 *ngIf="item1.planId == 6" class="small mt-2">
                                                        (5 Free Searches)
                                                    </h6> -->
                                                </div>
                                                <div *ngIf="item.isBsic == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td *ngIf="advanced == true">
                                                <div *ngIf="item.isAdvanced == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isAdvanced == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td *ngIf="pro == true">
                                                <div *ngIf="item.isPro == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isPro == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td *ngIf="proPlus == true">
                                                <div *ngIf="item.isProPlus == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isProPlus == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td *ngIf="elite == true">
                                                <div *ngIf="item.isElite == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isElite == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                        </tr>

                                        <!-- <tr *ngFor="let item of searchCategories">
                                            <td>
                                                {{item.name}}
                                            </td>
                                            <td>
                                                <div *ngIf="item.isBsic == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />                                                    
                                                </div>
                                                <div *ngIf="item.isBsic == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td>
                                                <div *ngIf="item.isAdvanced == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isAdvanced == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td>
                                                <div *ngIf="item.isPro == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isPro == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td>
                                                <div *ngIf="item.isProPlus == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isProPlus == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                            <td>
                                                <div *ngIf="item.isElite == true">
                                                    <img src="/assets/images/tick.svg" alt="" srcset="" />
                                                </div>
                                                <div *ngIf="item.isElite == false">
                                                    <img src="/assets/images/cancel.svg" alt="" srcset="" />
                                                </div>
                                            </td>
                                        </tr> -->
                                        
                                    </table>
                                </div>
                            </div>
                        </div>
                   
                </div>
            </div>
        </div>
        <p>Sign up for your free 30-Day Trial.</p>
        <p> <a class="nav-link" routerLink="/signup" routerLinkActive="active">Sign Up</a></p>
        <h3>CONTACT</h3>
        <p><strong>If you would like helping registering for your free trial or have a question, we invite you to
                contact us.</strong></p>
        <p> <a href="mailto:contact@enl.solutions" target="_blank">Contact Us</a></p>
    </div>
</section>